"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsListAudiences = exports.facebookAdsListAudiencesResultSchema = exports.facebookAdsListAudiencesArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsListAudiencesArgsSchema = zod_1.z.object({
    audienceType: zod_1.z
        .enum(['ALL', 'CUSTOM', 'SAVED', 'LOOKALIKE'])
        .default('ALL')
        .describe('Filter by audience type. CUSTOM includes uploaded lists and pixel audiences. LOOKALIKE filters lookalike audiences. SAVED are targeting templates.'),
    emitMode: zod_1.z.literal('single'),
});
exports.facebookAdsListAudiencesResultSchema = zod_1.z.object({
    customAudiences: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().describe('Audience ID'),
        name: zod_1.z.string().describe('Audience name'),
        subtype: zod_1.z
            .string()
            .describe('Audience subtype: CUSTOM, WEBSITE, APP, LOOKALIKE, ENGAGEMENT, etc.'),
        description: zod_1.z.string().optional().describe('Audience description'),
        approximate_count_lower_bound: zod_1.z.number().describe('Lower bound estimate of audience size'),
        approximate_count_upper_bound: zod_1.z.number().describe('Upper bound estimate of audience size'),
        delivery_status: zod_1.z.object({
            code: zod_1.z.number().describe('200 = ready, 300 = too small, 400+ = unusable'),
            description: zod_1.z.string(),
        }),
        origin_audience_id: zod_1.z.string().optional().describe('For lookalikes: source audience ID'),
        lookalike_spec: zod_1.z
            .object({
            type: zod_1.z.string().optional(),
            country: zod_1.z.string().optional(),
            ratio: zod_1.z.number().optional().describe('Lookalike percentage (0.01 = 1%)'),
        })
            .optional(),
        time_created: zod_1.z.string().optional(),
        time_updated: zod_1.z.string().optional(),
    }))
        .describe('List of custom audiences (includes lookalikes)'),
    savedAudiences: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().describe('Saved audience ID'),
        name: zod_1.z.string().describe('Saved audience name'),
        description: zod_1.z.string().optional(),
        approximate_count_lower_bound: zod_1.z.number().describe('Lower bound reach estimate'),
        approximate_count_upper_bound: zod_1.z.number().describe('Upper bound reach estimate'),
        run_status: zod_1.z.string().describe('ACTIVE or DELETED'),
        sentence_lines: zod_1.z
            .array(zod_1.z.string())
            .optional()
            .describe('Human-readable targeting description'),
        time_created: zod_1.z.string().optional(),
        time_updated: zod_1.z.string().optional(),
    }))
        .describe('List of saved audiences (targeting templates)'),
});
exports.facebookAdsListAudiences = (0, common_1.createToolMetadata)({
    id: 'facebookAdsListAudiences',
    displayName: 'List Meta Ad Audiences',
    displayDescription: 'List Custom, Saved, and Lookalike Audiences for a Meta ad account',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsListAudiencesArgsSchema,
}, exports.facebookAdsListAudiencesResultSchema);
